export enum Configuration {
  Structure = "mf-navbar-structure",
  ErrorStructure = "mf-parcel-custom-error-view-structure",
  LoadingStructure = "mf-parcel-loading-view",
}

export interface AllLayouts {
  defaultLayout: unknown;
}

export interface Props {
  mfeConfigs: {
    "mf-navbar-structure": any;
  };
  shared_structures: unknown;
}

export interface ReduxSliceConfig {
  name: string;
  initialState: any;
  reducers: ReduxReducerFunctions;
}

export interface ReduxReducerFunctions {
  [name: string]: Function;
}
